export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
          Ready to Buy?
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto leading-relaxed">
          Your <strong>LitBuy spreadsheet</strong> journey begins here. Explore thousands of products at unbeatable prices on our main platform.
        </p>

        <div className="mt-8">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-foreground-950 text-background-50 text-base md:text-lg font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-800 hover:scale-105 transition-all duration-300 shadow-lg"
          >
            buy it now
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-3 md:gap-4">
          {['Shoes', 'Hoodies', 'T-Shirts', 'Jackets', 'Bags', 'Accessories', 'Jersey', 'Sets'].map((item) => (
            <div
              key={item}
              className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-background-100 overflow-hidden"
            >
              <div className="w-full h-full flex items-center justify-center text-foreground-400">
                <i className="ri-shopping-bag-line text-lg md:text-xl"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}